import { render, staticRenderFns } from "./QComparisonStat.vue?vue&type=template&id=870f3764&scoped=true&"
import script from "./QComparisonStat.vue?vue&type=script&lang=js&"
export * from "./QComparisonStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870f3764",
  null
  
)

export default component.exports